import { render } from "./stay.vue?vue&type=template&id=add4258e&scoped=true"
import script from "./stay.vue?vue&type=script&lang=js"
export * from "./stay.vue?vue&type=script&lang=js"

import "./stay.vue?vue&type=style&index=0&id=add4258e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-add4258e"

export default script